import React from 'react';
import styled from 'styled-components';

interface CheckMarkProps {
  active: boolean;
  emphasize?: boolean;
  inline?: boolean;
}

interface StyledCheckMarkProps {
  $inline?: boolean;
  $emphasize?: boolean;
}

const CheckMarkContainer = styled.div<StyledCheckMarkProps>`
  display: ${props => (props.$inline ? 'inline-block' : 'block')};
  text-align: center;
  font-weight: ${props => (props.$emphasize ? 'bold' : 'normal')};
`;

const CheckMark = ({ active, emphasize, inline }: CheckMarkProps) => {
  return (
    <CheckMarkContainer $inline={inline} $emphasize={emphasize}>
      {active ? '✓' : ''}
    </CheckMarkContainer>
  );
};

export default CheckMark;
